import { ArticleModel } from "../archive/article.model";
import { QuotationDetailModel } from "./quotation-detail.model";

export class BreakdownModel {
  breakdownId: number = 0;
  quotationId: number = 0;
  quotationDetailId: number = 0;
  quotationDetail: QuotationDetailModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  clientValueList: number = 0;
  unitValue: number = 0;
  discountRate: number = 0;
  clientValue: number = 0;
  quantity: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
